import { am } from './utils';

import logger from '@/utils/logger';

export const PUSH = am('PUSH');

export const state = {
  path: '/',
  params: {}
};

const getters = {};

export const actions = {
  async push({ commit }, { path, params = {} }) {
    commit(PUSH.STARTED);

    try {
      commit(PUSH.COMPLETED, { path, params });
    } catch (e) {
      logger.error(e);
      commit(PUSH.FAILED);
    }
  }
};

export const mutations = {
  [PUSH.STARTED]() {},
  [PUSH.FAILED]() {},
  [PUSH.COMPLETED](state, { path, params }) {
    state.path = path;
    state.params = params;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
